(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var items = document.querySelectorAll('.gallery-item');
  var lightbox = document.createElement('div');
  lightbox.classList.add('lightbox');
  lightbox.innerHTML = '<span class="close">&times;</span><span class="arrow prev">&#10094;</span><span class="arrow next">&#10095;</span><div class="caption"></div>';
  document.body.appendChild(lightbox);

  var closeBtn = lightbox.querySelector('.close');
  var prevBtn = lightbox.querySelector('.arrow.prev');
  var nextBtn = lightbox.querySelector('.arrow.next');
  var caption = lightbox.querySelector('.caption');
  var img = document.createElement('img');
  lightbox.appendChild(img);

  var currentIndex = -1;

  function updateLightbox(index) {
    var item = items[index];
    img.src = item.querySelector('img').src;
    caption.textContent = item.querySelector('.gallery-caption').textContent;
  }

  items.forEach(function(item, index) {
    item.addEventListener('click', function() {
      currentIndex = index;
      updateLightbox(currentIndex);
      lightbox.style.display = 'flex';
    });
  });

  closeBtn.addEventListener('click', function() {
    lightbox.style.display = 'none';
  });

  prevBtn.addEventListener('click', function() {
    currentIndex = (currentIndex - 1 + items.length) % items.length;
    updateLightbox(currentIndex);
  });

  nextBtn.addEventListener('click', function() {
    currentIndex = (currentIndex + 1) % items.length;
    updateLightbox(currentIndex);
  });
});

  } catch(e) { console.error(e); }
})();
})();
